import React from 'react'
import './ErrorDisplay.scss'

import Popup from '../../partials/Popup/Popup.js'

export default function ErrorDisplay(props) {
    const getData = props => {
        if (props.data.error === "title-error") {
            return {
                header: "Google Sheets Error: Sheet Title does not match interaction",
                body: `<p>Found title "${props.data.title}" which does not match any current interactions.</p><p>This is either a spelling error in the Sheet Title or this interaction is currently unimplemented in the Sheets Editor.</p>`,
                button: "Next Segment"
            }
        } else if (props.data.error === "internal-error") {
            return {
                header: `Data Mapping Error for ${props.data.title}`,
                body: `Oops! Something went wrong loading this sheets data. Please contact an Allen dev and we'll get on it 😎`,
                button: "Next Segment"
            }
        } else {
            return {
                header: "Uncaught Data Error",
                body: `Oops! Something went wrong loading this sheets data. Please contact an Allen dev and we'll get on it 😎`,
                button: "Next Segment"
            }
        }
    }
    return (
        <div className="ErrorDisplay">
           <Popup
           data={getData(props)}
           scrim={true}
           onClose={props.onComplete}/>
        </div>
    )
}
